export var CATEGORY_KEY_PREFIX = "category:";
export var ALL_PRODUCTS_KEY = "All Products";
export var NEW_ARRIVALS_KEY = "New Arrivals";
export var BRAND_PAGE_PAGE_SIZE = 20;
